var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16.5,
    viewBox: "0 0 15.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M119.732,133.02l-.007-.007a.251.251,0,0,1-.026-.036s0-.007-.007-.01-.016-.026-.023-.039a.011.011,0,0,0,0-.007c-.007-.013-.013-.026-.02-.042s0,0,0-.007-.01-.029-.017-.046,0-.007,0-.007a.227.227,0,0,1-.01-.046.029.029,0,0,0,0-.016c0-.013,0-.026-.007-.039a.469.469,0,0,1,0-.111.163.163,0,0,1,.007-.039.029.029,0,0,1,0-.016c0-.016.007-.029.01-.046s0-.007,0-.007a.255.255,0,0,1,.017-.046s0,0,0-.007.013-.029.02-.042a.011.011,0,0,1,0-.007.243.243,0,0,1,.023-.039s0-.007.007-.01a.343.343,0,0,1,.026-.036l.007-.007a.467.467,0,0,1,.04-.042l3.263-3.227a.571.571,0,0,1,.8,0,.558.558,0,0,1,0,.794l-2.3,2.273h9.128a.56.56,0,1,1,0,1.12h-9.131l2.28,2.257a.558.558,0,0,1,0,.794.569.569,0,0,1-.8,0l-3.243-3.21C119.758,133.047,119.745,133.033,119.732,133.02Z",
    transform: "translate(-119.6 -124.666)",
    fill: "#b07f4a",
    stroke: "#b07f4a",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M22.39,1.12H18.167A.564.564,0,0,1,17.6.562.565.565,0,0,1,18.167,0H22.39a3.061,3.061,0,0,1,3.071,3.041v9.919A3.061,3.061,0,0,1,22.39,16H18.237a.56.56,0,1,1,0-1.12H22.39a1.933,1.933,0,0,0,1.94-1.92V3.041A1.933,1.933,0,0,0,22.39,1.12Z",
    transform: "translate(-10.461 0)",
    fill: "#b07f4a",
    stroke: "#b07f4a",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2895cc67be5d3435f8a2527e75c75d7b.svg";
export { ForwardRef as ReactComponent };